import Vue from "vue";
import {
  FORM_TYPE, FILE_TYPES
} from "../constants/custom-define-type";
import { TIME_FROM_TO_SEPARATOR } from "../constants/separator";

Vue.mixin({
  methods: {
    getApplicationEmailContent(applicationData, listFields, mapDependentObjects, listBookingJobs, isOneItemPerRow = false, additionalInformation, isEmailTemplate = false) {
      // Hide hidden fields
      listFields = listFields.filter(field => !field.excludeFromSummaryEmail && this.isItemShow(applicationData, field, listFields));
      let content = "<div style='opacity: 1; border: solid 1px #f0f3f4; padding: 0.5em;'>";
      for (const row of this.restructureListFields(listFields, isOneItemPerRow)) {
        content += "<div style='opacity: 1; display: table; width: 100%;'>";
        for (const field of row) {
          // Ignore some complex type fields
          if ([FORM_TYPE.FILE_WITH_INFO, FORM_TYPE.RATING_GROUP,
          FORM_TYPE.RADIO_TABLE, FORM_TYPE.PASSWORD].includes(field.type)) {
            continue;
          }
          // Handle HTML type
          if (field.type === FORM_TYPE.HTML) {
            content += field.html;
            continue;
          }
          // Handle separator
          if (field.type === FORM_TYPE.SEPARATOR) {
            content += "<hr style='opacity: 1; margin-bottom: 0'/>";
            continue;
          }

          // Handle list textbox
          if (field.type === FORM_TYPE.LIST_TEXTBOX) {
            content += this.getListTextboxContent(applicationData, field);
            continue;
          }


          // Handle dialog section (reference, experience, ...)
          if ([FORM_TYPE.SLOT, FORM_TYPE.SECTION, FORM_TYPE.BOOKING_SECTION].includes(field.type)) {
            content += this.getSectionContent(field, mapDependentObjects, listBookingJobs, isOneItemPerRow, isEmailTemplate);
            continue;
          }
          let percentWidth = 100;
          if (!isOneItemPerRow && field.itemPerRow) {
            percentWidth = percentWidth / field.itemPerRow;
          }
          // Handle header and subheader
          if ([FORM_TYPE.HEADER, FORM_TYPE.SUB_HEADER].includes(field.type)) {
            const marginTop = field.type === FORM_TYPE.HEADER ? '0.4em' : '0.2em';
            const fontSize = field.type === FORM_TYPE.HEADER ? '2em' : '1.5em';
            content += `<div style='opacity: 1; display: table-cell; width:${percentWidth}%; padding-top: 4px'>`
              + `<div style='opacity: 1; margin-top: ${marginTop}; font-size: ${fontSize};'><b>${this.getFieldPropertyByLang(field, 'label')}</b></div></div>`;
            continue;
          }
          if (field.type === FORM_TYPE.PLACEMENT_JOB_SELECTION) {
            content += this.getPlacementJobSelectionContent(field, applicationData.selected_placement_jobs);
            continue;
          }
          const value = applicationData[field.model];
          // Skip empty value
          if (value == null || value === "") {
            continue;
          }
          if (field.type === FORM_TYPE.FILE) {
            if (typeof value === 'string') {
              const url = this.convertToAbsolutePath(value);
              if (this.isFieldAnswerInline(field, additionalInformation)) {
                content += `<div style='opacity: 1; display: table-cell; width:${percentWidth}%; padding-top: 4px'><div><b>${this.getFieldPropertyByLang(field, 'label')
                  }: </b><a href="${url}">View</a></div></div>`;
              } else {
                content += `<div style='opacity: 1; display: table-cell; width:${percentWidth}%; padding-top: 4px'><div><b>${this.getFieldPropertyByLang(field, 'label')
                  }</b></div><div><a href="${url}">View</a></div></div>`;
              }
            }
            continue;
          }
          // Handle empty array
          if (Array.isArray(value)) {
            if (value.length === 0) {
              continue;
            }
          }
          if (this.isFieldAnswerInline(field, additionalInformation)) {
            const fieldValue = this.getDisplayFieldValue(
              applicationData,
              field,
              field.model,
              ', ',
              isEmailTemplate
            );
            content += `<div style='opacity: 1; display: table-cell; width:${percentWidth}%; padding-top: 4px'><div><b>${this.getFieldPropertyByLang(field, 'label')
              }: </b>${fieldValue}</div></div>`;
          } else {
            const fieldValue = this.getDisplayFieldValue(
              applicationData,
              field,
              field.model,
              '<br/>',
              isEmailTemplate
            );
            content += `<div style='opacity: 1; display: table-cell; width:${percentWidth}%; padding-top: 4px'><div><b>${this.getFieldPropertyByLang(field, 'label')
              }</b></div><div>${fieldValue}</div></div>`;
          }
        }
        content += "</div>";
      }
      return content + "</div>";
    },
    getPlacementJobSelectionContent(field, listSelectedIds) {
      if (!listSelectedIds || !listSelectedIds.length) {
        return "";
      }
      const listSelectedJobs = this.$store.getters.listPlacementJobs.filter(job => listSelectedIds.includes(job.id));
      const content = listSelectedJobs.map(job => `<li>${job.title}</li>`).join('');
      let result = `<div style='opacity: 1; display: table-cell; width:100%; padding-top: 4px'><div><b>${this.getFieldPropertyByLang(field, 'label')
        }</b></div><div><ul style="margin: 0;">${content}</ul></div></div>`;
      return result;
    },
    isFieldAnswerInline(field, additionalInformation) {
      console.log(additionalInformation);
      if (!field) {
        return false;
      }
      if (field.additionalInformation && field.additionalInformation.inline_answer) {
        return true;
      }
      if (field.additional_information && field.additional_information.inline_answer) {
        return true;
      }
      if (additionalInformation && additionalInformation.inline_answer) {
        return true;
      }
      return false;
    },
    // Get content for LIST_TEXTBOX
    getListTextboxContent(applicationData, field) {
      let content = "";
      if (applicationData[field.labelModel] == null || applicationData[field.labelModel].length === 0) {
        return content;
      }
      content += `<div><b>${this.getFieldPropertyByLang(field, 'label')}</b></div>`;
      const listSubContent = [];
      for (let index = 0; index < applicationData[field.labelModel].length; index++) {
        const label = applicationData[field.labelModel][index];
        const value = applicationData[field.model][index];
        // Group each two in a row
        if (index % 2 === 0) {
          listSubContent.push("<div style='opacity: 1; display: table; width: 100%;'>");
        }
        listSubContent.push(`<div style='opacity: 1; display: table-cell; width:50%; padding-top: 4px'><div><b>${label
          }</b></div><div>${value}</div></div>`);
        if (index % 2 === 1) {
          listSubContent.push("</div>");
        }
      }
      if (applicationData[field.labelModel].length % 2 === 0) {
        // Add missing close tag
        listSubContent.push("</div>");
      }
      content += `${listSubContent.join('')}`;
      return content;
    },
    // Get content for sections: booking, experience, references, ...
    getSectionContent(field, mapDependentObjects, listBookingJobs, isOneItemPerRow = false, isEmailTemplate = false, ignoreHeader = false) {
      let content = "";
      // Handle Booking
      if (field.name === "Booking") {
        if (listBookingJobs == null || listBookingJobs.length === 0) {
          return content;
        }
        if (!ignoreHeader) {
          const fontSize = isEmailTemplate ? '1em' : '2em';
          content += `<div><div style='opacity: 1; font-size: ${fontSize}; margin-top: 0.4em; margin-bottom:0.4em; font-weight: bold;'>${this.getFieldPropertyByLang(field, 'label')}</div>`;
        }
        for (const bookingJob of listBookingJobs) {
          let listFields = [{
            type: FORM_TYPE.HTML,
            html: `<label style='opacity: 1; font-size: 1.1em;'><b>${new Date(bookingJob.date + "T00:00:00").toDateString()}</b></label>`
          },
          ...field.list_fields,
          {
            type: FORM_TYPE.CHECKBOX_ITEM,
            label: "Do you want this service more than once (repeating/recurring)?",
            model: "repeat",
            isRequired: false
          }, {
            type: FORM_TYPE.DATEPICKER,
            label: "Repeat Until",
            model: "repeat_end_date",
            showIf: "repeat",
            minDate: this.selectedDate,
            initialView: "day",
          }, {
            type: FORM_TYPE.LABEL,
            label: "Repeat Every *",
            showIf: "repeat",
          }, {
            type: FORM_TYPE.MULTI_SELECT,
            model: "repeat_count",
            optionList: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
            showIf: "repeat",
            itemPerRow: 2,
          }, {
            type: FORM_TYPE.MULTI_SELECT,
            model: "repeat_type",
            optionList: ["Days", "Weeks"],
            showIf: "repeat",
            itemPerRow: 2,
          }, {
            type: FORM_TYPE.CHECKBOX,
            model: "repeat_weekdays",
            label: "Repeat On",
            optionList: [
              "Monday",
              "Tuesday",
              "Wednesday",
              "Thursday",
              "Friday",
              "Saturday",
              "Sunday",
            ],
            showIf: "repeat_type",
            showIfValue: ["Weeks"],
          },
          {
            type: FORM_TYPE.TEXTBOX,
            label: "Booking Address",
            model: "address1",
          }, {
            type: FORM_TYPE.TEXTBOX,
            label: "Address Line 2",
            model: "address2",
            isRequired: false,
          }, {
            type: FORM_TYPE.TEXTBOX,
            label: "City",
            itemPerRow: 3,
            model: "city",
          }, {
            type: FORM_TYPE.TEXTBOX,
            label: "State",
            itemPerRow: 3,
            model: "provincestate",
          }, {
            type: FORM_TYPE.TEXTBOX,
            label: "Zip Code",
            itemPerRow: 3,
            model: "postal_code",
          }, {
            type: FORM_TYPE.MULTI_SELECT,
            label: "How many children will be cared for?",
            optionList: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
            isMulti: false,
            model: "number_children",
          }];
          if (bookingJob.filler) {
            listFields.push({
              type: FORM_TYPE.TEXTBOX,
              label: "Selected Candidate",
              model: "filler_name",
              itemPerRow: 1
            });
          }
          content += this.getApplicationEmailContent(bookingJob, listFields, mapDependentObjects, listBookingJobs, isOneItemPerRow, field.additionalInformation, isEmailTemplate);
        }
        content += "</div>";
        return content;
      }

      // None booking sections: reference, experience, ...
      const listDependentObjects = mapDependentObjects[field.label];
      if (listDependentObjects == null || listDependentObjects.length === 0) {
        return content;
      }
      if (!ignoreHeader) {
        const fontSize = isEmailTemplate ? '1em' : '2em';
        content += `<div><div style='opacity: 1; font-size: ${fontSize}; margin-top: 0.4em; margin-bottom:0.4em; font-weight: bold;'>${this.getFieldPropertyByLang(field, 'label')}</div>`;
      }
      for (const dependentObject of listDependentObjects) {
        content += this.getApplicationEmailContent(dependentObject, field.list_fields, mapDependentObjects, listBookingJobs, isOneItemPerRow, field.additionalInformation, isEmailTemplate);
      }
      content += "</div>";
      return content;
    },
    // Restructure listFields, by group each fields by rows
    restructureListFields(listFields, isOneItemPerRow) {
      return listFields.reduce((accResult, cur) => {
        if (accResult.length === 0) {
          return [[cur]];
        }
        if (isOneItemPerRow || cur.itemPerRow == null || cur.itemPerRow === 1) {
          return [...accResult, [cur]];
        }
        const lastEl = accResult[accResult.length - 1];
        if (this.isFullBootstrapRow(lastEl)) {
          return [...accResult, [cur]];
        }
        accResult[accResult.length - 1].push(cur);
        return accResult;
      }, []);
    },
    // Get display value for each field
    getDisplayFieldValue(applicationData, item, key, separator, isEmailTemplate = false) {
      if (item.type === FORM_TYPE.TOTAL_YEARS) {
        return this.calculateDiffYears(
          applicationData.start_date,
          applicationData.end_date
        );
      }
      if (item.type === FORM_TYPE.LABEL) {
        return item.model;
      }
      if (item.type === FORM_TYPE.LIST_ITEMS) {
        return item.itemList;
      }
      let value = this.getValueOfObjectKey(applicationData, key);
      // Check share model
      if (item.isShareModel && Array.isArray(value)) {
        if (value[item.shareModelIndex]) {
          return value[item.shareModelIndex];
        } else {
          return "";
        }
      }
      if (item.type === FORM_TYPE.DAY_HOURS_SELECTOR) {
        if (value == null || value.length === 0) {
          return "";
        }
        // Convert list days from String to array
        const listWorkingDays = item.listDays
          .split("\n")
          .map((option) => option.trim())
          .filter((option) => option.length > 0);
        const listWorkingString = [];
        // Get string corresponding with each day with format Day: From hh:mm A To hh:mm A
        for (let index = 0; index < listWorkingDays.length; index++) {
          const timeValue = value[index];
          if (timeValue == null || timeValue.length === 0) {
            continue;
          }
          let timeTokens;
          if (timeValue.includes(TIME_FROM_TO_SEPARATOR)) {
            // New format (use with textbox)
            timeTokens = timeValue.split(TIME_FROM_TO_SEPARATOR);
          } else {
            // Old format (use with Timepicker)
            timeTokens = timeValue.split(",");
            if (timeTokens.length === 1) {
              timeTokens.push("");
            }
            timeTokens = timeTokens.slice(0, 2);
          }
          const mapReplacedValues = {
            ":AM": " AM",
            ":PM": " PM",
          };
          const timeFrom = timeTokens[0]
            ? this.replaceAllByMap(timeTokens[0], mapReplacedValues)
            : "";
          const timeTo = timeTokens[1]
            ? this.replaceAllByMap(timeTokens[1], mapReplacedValues)
            : "";
          let info = listWorkingDays[index] +
            `: From ${timeFrom} To ${timeTo}`;
          if (item.hasTimeOff && timeTokens.length > 2) {
            info = `${info} Time Off ${timeTokens[2]}`;
          }
          if (item.hasNote) {
            if (item.hasTimeOff && timeTokens[3]) {
              info = `${info} Note: ${timeTokens[3]}`;
            } else if (timeTokens[2]) {
              info = `${info} Note: ${timeTokens[2]}`;
            }
          }
          listWorkingString.push(info);
        }
        return listWorkingString.join(separator).trim();
      } else if (item.type === FORM_TYPE.SALARY_RANGE) {
        if (value == null || value.length < 3) {
          return "";
        }
        if (item.hidePeriod) {
          return "From: $" + value[0] + " To: $" + value[1];
        } else {
          return (
            "From: $" + value[0] + " To: $" + value[1] + " per " + value[2]
          );
        }
      } else if (item.type === FORM_TYPE.MONTH_PICKER) {
        return this.getDisplayMonthYear(value);
      }

      if (Array.isArray(value)) {
        if (item.isHtml) {
          return value.map(token => this.getHtmlText(token)).join(separator);
        } else {
          return value.join(separator);
        }
      }
      if (typeof value === "boolean") {
        return value ? "Yes" : "No";
      }
      if (typeof value === 'string') {
        if (item.isHtml) {
          value = this.getHtmlText(value);
        }
      }
      if (item.type === FORM_TYPE.FILE) {
        if (item.fileType === FILE_TYPES.IMAGE) {
          // If it is a image file, create URL to display image
          if (typeof value === "object" && value != null) {
            return URL.createObjectURL(value);
          }
        }
      } else if (item.type === FORM_TYPE.TIME_PICKER) {
        if (typeof value === 'string') {
          return this.convertTimeStringToStringAMPM(value);
        } else {
          return this.convertTimeAMPMToString(value);
        }
      } else if (item.type === FORM_TYPE.DATEPICKER) {
        try {
          const dateStr = new Date(value + "T00:00:00").toDateString();
          if (key === 'birthday') {
            if (isEmailTemplate) {
              return (
                "Age: " + this.getAge(value)
              );
            } else {
              return (
                dateStr +
                " (Age: " +
                this.getAge(value) +
                ")"
              );
            }
          }
          return dateStr;
        } catch (e) {
          return value;
        }
      } else if (item.type === FORM_TYPE.DATETIME_PICKER) {
        try {
          return new Date(value).toUTCString();
        } catch (e) {
          return value;
        }
      } else if (item.type === FORM_TYPE.YEAR_PICKER) {
        return this.getYearFromDate(value);
      }
      return value;
    },
    getFieldPropertyByLang(item, key) {
      const language = this.$store.getters.language;
      if (language) {
        if (item[key + "_lang_" + language]) {
          return item[key + "_lang_" + language];
        }
      }
      if (item[key]) {
        return item[key];
      }
      if (key === "label" && item.keyLangLabel) {
        if (item.keyLangLabelParams) {
          return this.getLabelByKeys(
            item.keyLangLabel,
            ...item.keyLangLabelParams
          );
        } else {
          return this.getLabelByKeys(item.keyLangLabel);
        }
      }
      return "";
    },
  }
});



// WEBPACK FOOTER //
// ./src/mixins/email-content.js